
globalThis.ContainersToggler = (function() {
  function ContainersToggler($html) {
    this.$html = $html;
    this.$togglables = this.$html.find('*[data-target="containers-toggler.togglable"]');
    this.$triggers = this.$html.find('*[data-target="containers-toggler.trigger"]');

    this.init();
  }

  ContainersToggler.init = function($ctx) {
    ($ctx || $('body')).find('*[data-sb-controller="containers-toggler"]').each(function() {
      new ContainersToggler($(this));
    });
  }

  ContainersToggler.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var moduleInstance = this;

      this.$triggers.each(function() {
        var $trigger = $(this),
            onMatch = $trigger.data('on-match') || 'default';

        $trigger.on('change', function() {
          moduleInstance.$togglables.each(function() {
            var $togglable = $(this),
                match = true;

            if($trigger.is(':checkbox') && onMatch == 'default') {
              match = match && $trigger.is(':checked');
            }
            match = match && $togglable.data('toggle-value').toString().split(',').indexOf($trigger.val()) > -1;

            if(match) {
              switch(onMatch) {
                case 'trigger_event':
                  $trigger.trigger('containers-toggler.match', [$trigger, $togglable]);
                  break;
                default:
                  $togglable.find('input,select,textarea').prop('disabled', false)
                  $togglable.show();
              }
            } else {
              $togglable.find('input,select,textarea').prop('disabled', true)
              $togglable.hide();
            }
          });
        });
        if(!$trigger.is(':radio') || $trigger.is(':checked')) {
          $trigger.trigger('change');
        }
      });
    }
  }

  return ContainersToggler;
})();
